export const config = () => ({
  appEnv: getAppEnvFromUrl(),
  embedded: getEmbedded(),
  isAllowedOrigin,
})

const ALLOWED_PARENT_ORIGINS: Record<string, Array<RegExp>> = {
  prod: [/^https:\/\/portal\.flockcover\.com$/],
  staging: [/^https:\/\/portal\.staging\.infra\.flockcover\.com$/, /^http:\/\/localhost:3000$/],
  dev: [/^https:\/\/portal\.dev\.infra\.flockcover\.com$/],
}

const isAllowedOrigin = (origin: string): boolean => {
  const env = config().appEnv
  const allowedOrigins = ALLOWED_PARENT_ORIGINS[env]

  return allowedOrigins.some((pattern) => pattern.test(origin))
}

const getEmbedded = () => window.self !== window.top

// @Hack fallback
const getAppEnvFromUrl = () => {
  if (window.location.origin.includes(`dev`)) {
    return `dev`
  }

  if (window.location.origin.includes(`staging`) || window.location.origin.includes(`localhost`)) {
    return `staging`
  }

  // ORDERING is important!
  if (window.location.origin.includes(`ui.prod.infra.flockcover.com`)) {
    return `prod`
  }

  throw new Error(`Can not build correctly without an application environment`)
}
